import React, { useContext } from "react";
import whatsappIcon from "../../assests/profile/whatsappIcon.svg";
import Context from "../../context/Context";
export default function WhatsAppButton({ phoneNumber, message }) {
  const { isMobile } = useContext(Context);
  const handleClick = () => {
    const encodedContent = encodeURIComponent(message);
    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    if (isMobile) {
      const url = `https://wa.me/${phoneNumber}?text=${encodedContent}`;
      window.open(url, "_blank");
    } else {
      if (isMobileDevice) {
        const url = `https://wa.me/${phoneNumber}?text=${encodedContent}`;
        window.open(url, "_blank");
      } else {
        const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedContent}`;
        window.open(url, "_blank");
      }
    }
  };
  return (
    <button
      onClick={handleClick}
      className="flex items-center justify-center gap-[10px]  py-[9px] px-[16px]  border-[#B1FFB7] border-[1px] rounded-[40px] whitespace-nowrap w-fit"
    >
      <img src={whatsappIcon} />
      Get notifications via WhatsApp
    </button>
  );
}
